"use client";

import axios from "axios";

const ctrl = {};
const API_KEY = "302d055f55bd45f5b94d1a3ef62f9c52";

ctrl.reverseGeocode = async (lat, lon) => {
  try {
    // 1️⃣ Consulta principal de geocodificación inversa
    const response = await axios.get(
      "https://api.geoapify.com/v1/geocode/reverse",
      {
        params: {
          lat,
          lon,
          apiKey: API_KEY,
          type: "street",
        },
      },
    );

    if (response.status !== 200 || !response.data.features?.length) {
      return null;
    }

    const props = response.data.features[0].properties;
    const mainStreet = props.street;

    // 2️⃣ Consulta de calles cercanas (usando categorías válidas)
    const nearbyRes = await axios.get("https://api.geoapify.com/v2/places", {
      params: {
        categories:
          "highway.residential,highway.primary,highway.secondary,highway.tertiary,highway.service",
        filter: `circle:${lon},${lat},80`, // radio de 80m, puedes ajustar
        apiKey: API_KEY,
        limit: 5, // máximo de resultados
      },
    });

    const nearbyStreets = nearbyRes.data.features
      ?.map((f) => f.properties.name)
      .filter((name) => name && name !== mainStreet)
      .slice(0, 2);

    const [cross1, cross2] = nearbyStreets || [];

    // 3️⃣ Construir dirección más legible
    let formattedAddress =
      props.address_line1 || mainStreet || "Ubicación sin nombre";

    if (cross1 && cross2) {
      formattedAddress += ` entre ${cross1} y ${cross2}`;
    }

    return {
      ...props,
      formattedAddress,
    };
  } catch (error) {
    console.error("Error al obtener dirección:", error);
    return null;
  }
};

export default ctrl;
